import { SaleOrderStatusEnum } from 'generated/api'
import { mapStatusOrder } from 'helpers/wording'

interface IProps {
  status: SaleOrderStatusEnum
}

const OrderStatusLabel = (props: IProps) => {
  switch (props.status) {
    case 'DRAFT':
      return (
        <span className="bg-[#E59601] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
    case 'NEW':
      return (
        <span className="bg-[#FCD102] py-2 inline-block mt-2 px-2 text-xs text-dark font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
    case 'CONFIRMED':
      return (
        <span className="bg-[#91A669] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
    case 'READY_TO_PICK_UP':
      return (
        <span className="bg-[#72BA24] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
    case 'COMPLETED':
      return (
        <span className="bg-[#3C5337] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
    case 'CANCELLED':
      return (
        <span className="bg-[#ff4d4d] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
    case 'CANCEL_APPROVAL':
      return (
        <span className="bg-[#3C7098] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
    default:
      return (
        <span className="bg-[#E59601] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
          {mapStatusOrder(props.status)}
        </span>
      )
  }
}

export default OrderStatusLabel
